/* Page espacios scripts
========================================================================== */

if (document.querySelectorAll('.contenedor-info-espacios')[0]) {
	document.querySelectorAll('.titulo')[0].classList.add('activo');
	document.querySelectorAll('.contenedor-info-espacios')[0].classList.add('mostrar');

	let titulos = document.querySelectorAll('.titulo');
	for (let i = 0; i < titulos.length; i++) {
		titulos[i].addEventListener('click', mostrar_panel_info);
		titulos[i].addEventListener('click', cambiar_img_fondo);
	}

	function mostrar_panel_info() {
		let titulos = document.querySelectorAll('.titulo');
		for (let i = 0; i < titulos.length; i++) {
			titulos[i].classList.remove('activo');
		}
		this.classList.add('activo');
		let paneles = document.querySelectorAll('.contenedor-info-espacios');
		for (let i = 0; i < paneles.length; i++) {
			paneles[i].classList.remove('mostrar');
		}
		document.querySelector('div[data-contenedor-id="' + this.dataset.id + '"]').classList.add('mostrar');
	}

	function cambiar_img_fondo() {
		document.querySelectorAll('.img-fondo')[0].style.backgroundImage = "url(" + this.dataset.url + ")";
	}
}
